<template>
  <div v-if="validCredits">
    <div class="pb-5">
      <ranch-button
        :route="{ name: 'invoice.welcome', query: $route.query }"
        :label="i18n.steps.labels.change_refill"
        icon="chevron-left"
        action="action-secondary inline-flex"
      ></ranch-button>
    </div>

    <div class="flex">
      <fade-transition group class="flex-1 flex">
        <div
          class="flex-1"
          v-if="billingUpdate.display || needsToUpdatePersonalData"
          key="update-billing-contact"
        >
          <update-billing-contact
            :account="form"
            @cancel="billingUpdate.display = false"
            @settings-updated="updateBillingSettings"
          ></update-billing-contact>
        </div>
        <billing-informations
          class="flex-1 mr-5"
          @to-modify="showBillingDataForm"
          v-if="!billingUpdate.display && !needsToUpdatePersonalData"
          key="billing-information"
        ></billing-informations>
        <confirm-refill
          class="flex-1"
          :credits="credits"
          :country-id="form.country_id"
          :is-company="form.invoice_to"
          :vat-number="vatNumber"
          v-if="
            !billingUpdate.display &&
            form !== undefined &&
            !needsToUpdatePersonalData
          "
          @confirm="confirmRefill"
          key="confirm-refill"
        ></confirm-refill>
      </fade-transition>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handleAxiosError } from "@/boot/functions";

import BillingInformations from "./BillingInformations";
import UpdateBillingContact from "./Forms/UpdateBillingContact";
import ConfirmRefill from "./Forms/ConfirmRefill";

import NewRefillModalContent from "./NewRefill";
import NewRefillModalConfig from "../Modals/configs/newrefill";

export default {
  components: {
    BillingInformations,
    ConfirmRefill,
    UpdateBillingContact,
  },
  data() {
    return {
      credits: this.$route.query.credits,
      billingUpdate: {
        display: false,
      },
    };
  },
  methods: {
    showBillingDataForm(account) {
      if (this.form === undefined) {
        this.$store.commit("safe/setForm", account);
      }
      this.billingUpdate.display = true;
    },

    updateBillingSettings(settings) {
      this.$store.commit("safe/setForm", settings);
      this.billingUpdate.display = false;
    },

    confirmRefill(external_ref) {
      this.$store.commit("safe/setForm", {
        ...this.form,
        credits: this.credits,
        external_ref,
      });
      this.createRefill();
    },

    createRefill() {
      axios
        .post("/api/app/refills", {
          firstname: this.form.firstname,
          lastname: this.form.lastname,
          invoice_to: this.form.invoice_to,
          company: this.form.company,
          vat: this.vatNumber,
          add_main: this.form.add_main,
          add_zip: this.form.add_zip,
          add_state: this.form.add_state,
          add_city: this.form.add_city,
          country_id: this.form.country_id,

          credits: this.form.credits,
          external_ref: this.form.external_ref,

          user_activity: this.form.user_activity, // WTF sweb backend ????
        })
        .then(({ data }) => {
          this.$store.commit("safe/setForm", undefined);
          this.$store.commit("safe/addRefill", data);
          this.$store.dispatch("account/updateSafe");
          this.$router.push({
            name: "invoice.index",
            params: { id: data.id, locale: this.$route.params.locale },
          });

          this.promptPayment(data);
        })
        .catch(handleAxiosError);
    },
    promptPayment(data) {
      this.$modal.show(
        NewRefillModalContent,
        {
          step: 3,
          existingRefill: data,
        },
        NewRefillModalConfig
      );
    },
  },
  computed: {
    form() {
      return this.$store.state.safe.form;
    },

    vatNumber() {
      return this.form.invoice_to == "1" ? this.form.vat : "";
    },

    i18n() {
      return this.$store.state.safe.i18n.new_refill;
    },

    needsToUpdatePersonalData() {
      let contact = this.$store.state.safe.form;

      if (contact.add_city === undefined || contact.add_city === "") {
        return true;
      }

      if (
        contact.add_country === undefined ||
        contact.add_country === "" ||
        contact.country_id === 0
      ) {
        return true;
      }

      if (contact.add_main === undefined || contact.add_main === "") {
        return true;
      }

      if (contact.add_zip === undefined || contact.add_zip === "") {
        return true;
      }

      if (contact.user_activity === undefined || contact.user_activity === "") {
        return true;
      }

      if (contact.invoice_to == 1 && contact.company === "") {
        return true;
      }

      return false;
    },
    validCredits() {
      return this.credits && this.credits >= 1;
    },
  },
  mounted() {
    if (!this.validCredits) {
      this.$router.replace({ name: "invoice.welcome" });
      return;
    }
    if (this.form === undefined) {
      this.$store.commit("safe/setForm", this.$store.state.account.contact);
    }
  },
};
</script>
